<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoOverview()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form" v-if="isRunningInBrowser">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>2</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 2 - Abonneren</v-list-tile-title>
						<v-list-tile-sub-title>Welk abonnement wil je afsluiten?</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" mb-4>
				<h3>De betaling voor je abonnement is gelukt!</h3><br>
				<p>We hebben je een mail gestuurd met de bevestiging van je abonnement en de factuur.</p>
				<p>Om je E-Finder te activeren, moet deze eerst gekoppeld worden aan je telefoon. Dit gaat via Bluetooth in onze E-Finder app.</p>
				<p>Open de app op je telefoon. Als je hem nog niet hebt, download de app in de Appstore of Playstore.</p>
				<p></p>
				<v-layout row justify-center align-center mb-4>
					<a href="https://apps.apple.com/nl/app/e-finder/id1459518895">
						<img :src="images.badgeAppStore" height="40px" contain/>
					</a>
					<a href="https://play.google.com/store/apps/details?id=com.e_finder.app&gl=NL">
						<img :src="images.badgePlayStore" height="60px" contain/>
					</a>
				</v-layout>
				<v-btn block dark depressed large color="primary" @click="gotoOverview()">
					Terug naar het overzicht
				</v-btn>
			</v-container>
		</v-content>

		<v-content class="uf-form" v-else>
			<div v-if="device">
				<v-list two-line class="ma-0 pa-0">
					<v-list-tile two-line avatar class="e-connectz_list-tile">
						<v-list-tile-avatar>
							<strong>3</strong>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
							<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
				<v-container class="item-group">
					<h3>Voordat we beginnen, gaan we eerst controleren of je E-finder in goede orde is</h3><br/>
					<p>Kijk naar het LED lampje in het logo op de voorkant van de E-finder. Als het goed is knippert de E-finder elke 15 seconden of vaker wanneer je deze beweegt. Is dit het geval dan kan je verder naar de volgende stap door op Verder te klikken. Is dit NIET het geval volg dan de stappen hieronder.</p>
					<v-btn @click="next()" block dark depressed large color="primary">
						Verder
					</v-btn>
				</v-container>
				<v-container class="item-group">
					<h3>Reset de E-finder</h3>
					<p>Dit doe je door het eind van een paper-clip in het kleine gaatje rechts van de aansluiting aan de onderkant van je E-finder te steken. Steek de paperclip in het gaatje voor 5 seconden en als je het eruit haalt moet de LED 3 keer snel knipperen. Daarna moet deze elke 15 seconden knipperen (of vaker als je de E-Finder beweegt). Zo wel, klik op Verder. </p>
				</v-container>
				<v-container class="item-group">
					<h3>Knippert de E-finder nog steeds niet?</h3>
					<p>Dan moet deze opgeladen worden. Gebruik de oplaadkabel en sluit de E-finder aan op het netstroom. Wacht daarna een minuut of 20. Haal dan de E-finder van de stroom af en reset deze nog een keer zoals hierboven is beschreven. Als de E-finder nog steeds niet knippert, neem dan contact op met onze klantenservice.</p>
				</v-container>
			</div>
		</v-content>
	</div>
</template>

<script>
  import badgePlayStore from '../../../assets/images/badge-nl-google-play.png';
  import badgeAppStore from '../../../assets/images/badge-nl-app-store.svg';
  import DeviceService from '../../../services/DeviceService';

  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
      isRunningInBrowser() {
        return process.env.CORDOVA_PLATFORM === 'browser';
      }
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '')
            .toUpperCase();
        });
      }
    },
    data() {
      return {
        code: '',
        state: 'idle',
        images: {
          badgeAppStore: badgeAppStore,
          badgePlayStore: badgePlayStore
        },
      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      gotoOverview() {
        this.$router.push({ name: 'devices.list' });
      },
      next() {
		  this.$router.push({ name: 'devices.activate.pin' });
      }
    },
    created() {
      this.$store.dispatch('selectDevice', this.$route.params.id)
        .then((d) => {
          this.code = d.id_for_humans;
        });
    },
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
